query allBets(
  $first: Int,
  $offset: Int,
  $filter: BetFilter,
  ) {
  allBets(
      first: $first,
      offset: $offset,
      filter: $filter,
      orderBy: ACCEPTANCE_TIME_DESC
    ) {
    nodes {
      acceptanceTime
      betId
      operatorId
      playerAccountId
      accountInfo: accountByPlayerAccountIdAndOperatorId {
        nickname
        strength
        stakeFactor
        maxBetPercentage
        profilingLabels
      }
      betStake
      betType
      betPayout
      betActions
      betOutcome
      inferredDecimalPrice
      inferredBetProbability
      inferredOriginalFormattedPrice
      isFlagged
      flagType
      betPartGroups
      hasExternalParts
      betPartsByBetId {
        nodes {
          betId
          price
          limit
          marketId
          marketType
          marketSummary
          selection
          selectionId
          selectionType
          betPartOutcome
          event {
            eventName
            eventId
            competition {
              competitionName
            }
            competitors
            sportId
            sport {
              sportLabel
            }
            isUsaView
          }
        }
      }      
    }
  }
}
